import type { PlanktonPredefinedRight } from "~~/server/plankton";
import type { User } from "#auth-utils";

export function hasRight(user: User | null, right: PlanktonPredefinedRight): boolean {
  if (!user || !user.rights) {
    return false;
  }

  return user.rights.includes(right);
}

export function hasAllRights(user: User | null, ...rights: Array<PlanktonPredefinedRight>): boolean {
  return rights.every(right => hasRight(user, right));
}

/**
 * Checks if the user has the required right.
 * If the user does not have the right, it throws an error with a 403 Forbidden status code.
 * @param right The required right to check
 * @param user The user to check the right against. If not provided, it will use the current user from the session.
 * @throws {Error} If the user does not have the required right. Generates a 403 Forbidden HTTP status code.
 */
export function checkRight(right: PlanktonPredefinedRight, user?: User | null): void {
  if (user === undefined) {
    const userSession = useUserSession();
    user = userSession?.user?.value;
  }

  if (!hasRight(user, right)) {
    throw createError({
      statusCode: 403,
      statusMessage: "Forbidden",
      fatal: false, // This prevents it from being logged as an error
    });
  }
}
